var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dropdownPricingType"}},[_c('DropdownComponent',{attrs:{"label":"ประเภทราคาภาษี","trackBy":"value","options":_vm.optionsPricingType,"searchBy":"name","selected":_vm.selectPricingType,"search":false},on:{"update:selected":function($event){_vm.selectPricingType=$event}},scopedSlots:_vm._u([{key:"selected",fn:function(ref){
var props = ref.props;
return [_c('p',[_vm._v(_vm._s(props.name))])]}},{key:"options",fn:function(ref){
var props = ref.props;
return [_c('p',[_vm._v(_vm._s(props.name))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }